export const maxInt8 = 2n ** (8n - 1n);
export const maxInt16 = 2n ** (16n - 1n);
export const maxInt24 = 2n ** (24n - 1n);
export const maxInt32 = 2n ** (32n - 1n);
export const maxInt40 = 2n ** (40n - 1n);
export const maxInt48 = 2n ** (48n - 1n);
export const maxInt56 = 2n ** (56n - 1n);
export const maxInt64 = 2n ** (64n - 1n);
export const maxInt72 = 2n ** (72n - 1n);
export const maxInt80 = 2n ** (80n - 1n);
export const maxInt88 = 2n ** (88n - 1n);
export const maxInt96 = 2n ** (96n - 1n);
export const maxInt104 = 2n ** (104n - 1n);
export const maxInt112 = 2n ** (112n - 1n);
export const maxInt120 = 2n ** (120n - 1n);
export const maxInt128 = 2n ** (128n - 1n);
export const maxInt136 = 2n ** (136n - 1n);
export const maxInt144 = 2n ** (144n - 1n);
export const maxInt152 = 2n ** (152n - 1n);
export const maxInt160 = 2n ** (160n - 1n);
export const maxInt168 = 2n ** (168n - 1n);
export const maxInt176 = 2n ** (176n - 1n);
export const maxInt184 = 2n ** (184n - 1n);
export const maxInt192 = 2n ** (192n - 1n);
export const maxInt200 = 2n ** (200n - 1n);
export const maxInt208 = 2n ** (208n - 1n);
export const maxInt216 = 2n ** (216n - 1n);
export const maxInt224 = 2n ** (224n - 1n);
export const maxInt232 = 2n ** (232n - 1n);
export const maxInt240 = 2n ** (240n - 1n);
export const maxInt248 = 2n ** (248n - 1n);
export const maxInt256 = 2n ** (256n - 1n);
export const minInt8 = -(2n ** 8n);
export const minInt16 = -(2n ** 16n);
export const minInt24 = -(2n ** 24n);
export const minInt32 = -(2n ** 32n);
export const minInt40 = -(2n ** 40n);
export const minInt48 = -(2n ** 48n);
export const minInt56 = -(2n ** 56n);
export const minInt64 = -(2n ** 64n);
export const minInt72 = -(2n ** 72n);
export const minInt80 = -(2n ** 80n);
export const minInt88 = -(2n ** 88n);
export const minInt96 = -(2n ** 96n);
export const minInt104 = -(2n ** 104n);
export const minInt112 = -(2n ** 112n);
export const minInt120 = -(2n ** 120n);
export const minInt128 = -(2n ** 128n);
export const minInt136 = -(2n ** 136n);
export const minInt144 = -(2n ** 144n);
export const minInt152 = -(2n ** 152n);
export const minInt160 = -(2n ** 160n);
export const minInt168 = -(2n ** 168n);
export const minInt176 = -(2n ** 176n);
export const minInt184 = -(2n ** 184n);
export const minInt192 = -(2n ** 192n);
export const minInt200 = -(2n ** 200n);
export const minInt208 = -(2n ** 208n);
export const minInt216 = -(2n ** 216n);
export const minInt224 = -(2n ** 224n);
export const minInt232 = -(2n ** 232n);
export const minInt240 = -(2n ** 240n);
export const minInt248 = -(2n ** 248n);
export const minInt256 = -(2n ** 256n);
export const maxUint8 = 2n ** 8n;
export const maxUint16 = 2n ** 16n;
export const maxUint24 = 2n ** 24n;
export const maxUint32 = 2n ** 32n;
export const maxUint40 = 2n ** 40n;
export const maxUint48 = 2n ** 48n;
export const maxUint56 = 2n ** 56n;
export const maxUint64 = 2n ** 64n;
export const maxUint72 = 2n ** 72n;
export const maxUint80 = 2n ** 80n;
export const maxUint88 = 2n ** 88n;
export const maxUint96 = 2n ** 96n;
export const maxUint104 = 2n ** 104n;
export const maxUint112 = 2n ** 112n;
export const maxUint120 = 2n ** 120n;
export const maxUint128 = 2n ** 128n;
export const maxUint136 = 2n ** 136n;
export const maxUint144 = 2n ** 144n;
export const maxUint152 = 2n ** 152n;
export const maxUint160 = 2n ** 160n;
export const maxUint168 = 2n ** 168n;
export const maxUint176 = 2n ** 176n;
export const maxUint184 = 2n ** 184n;
export const maxUint192 = 2n ** 192n;
export const maxUint200 = 2n ** 200n;
export const maxUint208 = 2n ** 208n;
export const maxUint216 = 2n ** 216n;
export const maxUint224 = 2n ** 224n;
export const maxUint232 = 2n ** 232n;
export const maxUint240 = 2n ** 240n;
export const maxUint248 = 2n ** 248n;
export const maxUint256 = 2n ** 256n;
//# sourceMappingURL=number.js.map